import type { InvoicesRepository } from '@/core/invoices'
import type { UseCase } from '@/core/shared'

export const payPlanInvoice: UseCase<InvoicesRepository, 'payPlanInvoice'> = repository => {
  return async (invoiceId) => {
    await repository.payPlanInvoice(invoiceId)
  }
}
